
import { motion, useAnimation, useInView } from 'framer-motion'

import { useEffect, useRef } from "react";

interface Props {
  children: React.ReactNode;
  width?: "fit-content" | "100%";
}
export default function Reveal({ children, width = "fit-content" }: Props) {
    const ref = useRef(null);
    const isInVeiew = useInView(ref, { once: true });
const mainControls = useAnimation();
    useEffect(() => {
      if (isInVeiew) {
        mainControls.start("visible");
      }
      
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isInVeiew]);

  return (
    <div  ref={ref} style={{ position: "relative", width,  backgroundColor:'transparent' }}>
      <motion.div
       
        variants={{
          hidden: { opacity: 0, y: 100 },
          visible: { opacity: 1, y: 0 },
        }}
        initial="hidden"
        animate={mainControls}
        transition={{ duration: .6, delay: 0.5 }}
      >
        {children}
      </motion.div>
    </div>
  );
}
